export default {"src":"/_next/static/media/x-twitter.377a7df0.svg","height":512,"width":512};